export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Red.021b2980.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};